// extracted by mini-css-extract-plugin
export default {"layout-sidebar-container":"LayoutsSidebar_layout-sidebar-container__emy5E"};